import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import MessageContainer from '../components/Message/MessageContainer';
import { ImageClipboardProvider } from '../hooks/imageClipboard';
import ListUserStatus from '../components/Message/ListUserStatus';

import CadUserIcon from '../assets/icon/cardUser.svg';
import MensagemBoldIcon from '../assets/icon/mensagemBold.svg';

import { useUserStatus } from '../hooks/userStatus';
import { useToast } from '../hooks/toast';
import { useMessage } from '../hooks/message';
import { formatLocalDateTime, isSameLocalDay } from '../utils/dateTime';

interface UsersGroupChat {
  seqGrupoConversa: number;
  usuarios: string[];
}

const ChatUser: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [usuarios, setUsuarios] = useState<string[]>([]);
  const { userStatus } = useUserStatus();
  const { addToast } = useToast();
  const [statusReadOnly, setStatusReadOnly] = useState(false);

  const {
    messagesGroup,
    getMensagesGroup,
    chatUser,
    usersGroupChat,
    updateMensageRead,
    getUserGroupMsg,
    getChatGroup,
  } = useMessage();

  const id =
    searchParams.get('id') === null ? 0 : Number(searchParams.get('id'));

  const dataChat = chatUser.find((chat) => chat.seqGrupoConversa === id);

  useEffect(() => {
    const getUsers = async (): Promise<void> => {
      const userGroup = await getUserGroupMsg(id);

      setUsuarios(userGroup.usuarios);
    };

    const chatHistorico = chatUser.find((chat) => chat.seqGrupoConversa === id);

    getUsers();
    getChatGroup(id);
    getMensagesGroup(id, [], dataChat?.chatHistorico ?? 'N');
    if (chatHistorico?.chatHistorico !== 'S') updateMensageRead(id);
  }, [id]);

  useEffect(() => {
    setStatusReadOnly(!isSameLocalDay(dataChat?.dataConversa, new Date()));
  }, [dataChat?.dataConversa]);

  const msg = messagesGroup.find((message) => message.seqGrupoConversa === id);

  const getSubtitle = (dataChatTitle?: {
    chatHistorico?: string;
    dataConversa?: string;
  }): string => {
    if (dataChatTitle?.chatHistorico === 'S') {
      return 'Histórico de conversa';
    }

    if (dataChatTitle?.dataConversa) {
      return formatLocalDateTime(dataChatTitle.dataConversa, 'dd/MM/yyyy');
    }

    return 'Data inválida';
  };

  return (
    <div className="h-100">
      <div style={{ height: '4rem' }}>
        <span
          style={{
            fontSize: '2.5rem',
            fontWeight: '600',
          }}
        >
          Chat
        </span>
      </div>
      <div className="d-flex px-1 pb-2" style={{ height: 'Calc(100% - 4rem)' }}>
        <div
          style={{
            height: '100%',
            width: '30rem',
            borderRadius: '0.68rem',
            boxShadow: '0px -1px 5px 3px rgba(0, 0, 0, 0.25)',
            backgroundColor: '#FFF',
          }}
        >
          <div>
            <div
              style={{
                backgroundColor: '#1A1A1A',
                borderTopLeftRadius: '0.68rem',
                borderTopRightRadius: '0.68rem',
              }}
            >
              <div className="d-flex align-items-center ms-3">
                <Image
                  src={CadUserIcon}
                  style={{ width: '1.8rem', height: '1.8rem' }}
                />
                <span
                  style={{
                    fontSize: '1.68rem',
                    fontWeight: '600',
                    color: '#FFF',
                    marginLeft: '0.8rem',
                  }}
                >
                  Usuários
                </span>
              </div>
            </div>
            <div style={{ height: '70vh', overflow: 'auto' }}>
              <ListUserStatus
                msgDefaultWithoutUser="Não há usuários nesse chat"
                users={userStatus.filter((usr) => usuarios.includes(usr.user))}
              />
            </div>
          </div>
        </div>
        <section
          style={{
            height: '100%',
            marginLeft: '1rem',
            marginBottom: '1rem',
            borderRadius: '0.68rem',
            boxShadow: '0px -1px 5px 3px rgba(0, 0, 0, 0.25)',
            overflow: 'hidden',
            flex: '1',
          }}
        >
          <div
            className="d-flex flex-column"
            style={{
              height: '100%',
              width: '100%',
              borderTopLeftRadius: '0.68rem',
              borderTopRightRadius: '0.68rem',
            }}
          >
            <div className="d-flex align-items-center ms-2 ">
              <Image
                src={MensagemBoldIcon}
                style={{ width: '1.8rem', height: '1.8rem' }}
              />
              <span
                style={{
                  fontSize: '1.68rem',
                  color: '#000',
                  fontWeight: '600',
                  marginLeft: '0.5rem',
                }}
              >
                {`${dataChat?.nomeGrupo} - ${getSubtitle(dataChat)}`}
              </span>
            </div>

            <ImageClipboardProvider>
              <MessageContainer messagesGroup={msg} readOnly={statusReadOnly} />
            </ImageClipboardProvider>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ChatUser;
